'use client'
import { motion, useMotionValue, useTransform, animate } from 'framer-motion'
import { useEffect, useState } from 'react'
import RedoAnimText from './redo-anim-text'
import CursorBlinker from './cursor-blinker'

export interface IAnimTextProps {
  delay: number
}

export default function AnimText({ delay }: IAnimTextProps) {
  return (
    <span className="">
      <RedoAnimText delay={delay + 1} />
      <CursorBlinker />
    </span>
  )
}
